import { render, staticRenderFns } from "./ShoppingCards.vue?vue&type=template&id=4585b8e2"
import script from "./ShoppingCards.vue?vue&type=script&lang=js"
export * from "./ShoppingCards.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCards.vue?vue&type=style&index=0&id=4585b8e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports